<div
  *ngIf="{isFocus: (focus$ | async)} as streams$"
  class="box"
  [class._focus]="streams$.isFocus"
  [class._error]="error$ | async"
>
  <ng-content></ng-content>
</div>
